@if (true) {
    <div class="card">
        <div class="card-body">
            <div class="modal-body ">
                <form [formGroup]="FeatureEntry" (ngSubmit)="onFeatureSubmit(FeatureEntry.value);">
                    <div class="row">
                        <div class="col-auto col-sm-6 text-end">
                            <label class="form-label" >Module</label>
                        </div>
                        <div class="col-auto col-sm-6">
                            <input type="hidden" [formControlName]="'FeatureID'" [(ngModel)]="this.FeatureID" /> {{this.FeatureData.ModuleDs}}
                        </div>
                        <div class="col-auto col-sm-6 text-end">
                            <label class="form-label" >Feature</label>
                        </div>
                        <div class="col-auto col-sm-6">
                            {{this.FeatureData.FeatureDs}}
                        </div>
                        <div class="col-auto col-sm-6 text-end">
                            <label class="form-label" >Send Notification To Client</label>
                        </div>
                        <div class="col-auto col-sm-6">
                            <input type="checkbox" [checked]="this.FeatureData.IsClient" [(ngModel)]="this.FeatureData.IsClient" [formControlName]="'chkToClient'" />
                        </div>
                        <div class="col-auto col-sm-6 text-end">
                            <label class="form-label" >Active</label>
                        </div>
                        <div class="col-auto col-sm-6">
                            <input type="checkbox" [checked]="this.FeatureData.recEnable" [(ngModel)]="this.FeatureData.recEnable" [formControlName]="'chkIsActive'" />
                        </div>
                    </div>
            
                    <!-- <div class="col-sm-4 height-34">Module</div>
                    <div class="col-sm-5 height-34">
                        <input type="hidden" [formControlName]="'FeatureID'" [(ngModel)]="this.FeatureID" /> {{this.FeatureData.ModuleDs}}
                    </div>
                    <div class="col-sm-3">&nbsp;</div>
                    <div class="col-sm-12">
                        <hr>
                    </div> -->
            
                    <!-- <div class="col-sm-4 height-34">Feature</div>
                    <div class="col-sm-5 height-34">{{this.FeatureData.FeatureDs}}</div>
                    <div class="col-sm-3">&nbsp;</div>
                    <div class="col-sm-12">
                        <hr>
                    </div> -->
            
                    <!-- <div class="col-sm-4 height-34">Send Notification To Client</div>
                    <div class="col-sm-5" style="padding-top:5px;">
                        <input type="checkbox" [checked]="this.FeatureData.IsClient" [(ngModel)]="this.FeatureData.IsClient" [formControlName]="'chkToClient'" />
                    </div>
                    <div class="col-sm-3">&nbsp;</div>
                    <div class="col-sm-12">
                        <hr>
                    </div> -->
            
                    <!-- <div class="col-sm-4 height-34">Active</div>
                    <div class="col-sm-5" style="padding-top:5px;">
                        <input type="checkbox" [checked]="this.FeatureData.recEnable" [(ngModel)]="this.FeatureData.recEnable" [formControlName]="'chkIsActive'" />
                    </div>
                    <div class="col-sm-3">&nbsp;</div>
                    <div class="col-sm-12">
                        <hr>
                    </div> -->
            
            
                    <!-- <div class="col-sm-12">&nbsp;</div>
            
                    <div class="col-sm-4">&nbsp;</div>
                    <div class="col-sm-5"><input class="btn btn-primary" type="submit" value="Save"></div>
                    <div class="col-sm-3"></div>
                    <div class="form-group mt-2" style="display:none;">
                        <div class="form-check">
                            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                            <label for="autoClose">Auto close alert after three seconds</label>
                        </div>
            
                    </div>
                    <div class="jumbotron p-4">
                        <div class="container text-center col-sm-4 alertCss">
                            <app-alert></app-alert>
                            <router-outlet></router-outlet>
                        </div>
                    </div> -->
                </form>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-3">
        <button class="btn btn-primary submit-btn small " type="submit">
            Save
        </button>   
    </div>
}@else {
    <!-- <div class="modal-body  col-sm-12 form-group">
        <form [formGroup]="FeatureEntry" (ngSubmit)="onFeatureSubmit(FeatureEntry.value);">
    
            <div class="col-sm-4 height-34">Module</div>
            <div class="col-sm-5 height-34">
                <input type="hidden" [formControlName]="'FeatureID'" [(ngModel)]="this.FeatureID" /> {{this.FeatureData.ModuleDs}}
            </div>
            <div class="col-sm-3">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Feature</div>
            <div class="col-sm-5 height-34">{{this.FeatureData.FeatureDs}}</div>
            <div class="col-sm-3">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Send Notification To Client</div>
            <div class="col-sm-5" style="padding-top:5px;">
                <input type="checkbox" [checked]="this.FeatureData.IsClient" [(ngModel)]="this.FeatureData.IsClient" [formControlName]="'chkToClient'" />
            </div>
            <div class="col-sm-3">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Active</div>
            <div class="col-sm-5" style="padding-top:5px;">
                <input type="checkbox" [checked]="this.FeatureData.recEnable" [(ngModel)]="this.FeatureData.recEnable" [formControlName]="'chkIsActive'" />
            </div>
            <div class="col-sm-3">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
    
            <div class="col-sm-12">&nbsp;</div>
    
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-5"><input class="btn btn-primary" type="submit" value="Save"></div>
            <div class="col-sm-3"></div>
            <div class="form-group mt-2" style="display:none;">
                <div class="form-check">
                    <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                    <label for="autoClose">Auto close alert after three seconds</label>
                </div>
    
            </div>
            <div class="jumbotron p-4">
                <div class="container text-center col-sm-4 alertCss">
                    <app-alert></app-alert>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </form>
    </div> -->
}
